import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import styled from "styled-components";
import ChatSlogan from "./subs/ChatSlogan";
import ChatMessages from "./subs/ChatMessages";
import dynamic from "next/dynamic";
import sadAnimation from "@/public/lottie/niora/Sad.json";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

const ChatContent = (): ReactNode => {
  const { t } = useTranslation();

  return (
    <StyledChatContent>
      {/*<ChatSlogan />*/}
      {/*<ChatMessages />*/}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%"
        }}
      >
        <Lottie
          animationData={sadAnimation}
          style={{
            width: 135,
            height: 135
          }}
        />
        <div>{t("chatWidget.notReady.title")}</div>
        <div>{t("chatWidget.notReady.message")}</div>
      </div>
    </StyledChatContent>
  );
};

const StyledChatContent = styled.div`
  flex: auto;
  background-image: url("/images/chat-bg.png");
  background-repeat: repeat;
  background-size: 100%;
  overflow: auto;
  color: #111113 !important;
  padding: 0 12px 12px 12px;
`;

export default ChatContent;
